 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/Cover'
 import XHTMLFRONT from '@/components/xhtml/Front'
 import XHTMLTITLE from '@/components/xhtml/Title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLCONTENTS from '@/components/xhtml/Contents'
 import XHTMLFOREWORD from '@/components/xhtml/Foreword'
 import XHTMLPREFACE001 from '@/components/xhtml/Preface001'
 import XHTMLPREFACE002 from '@/components/xhtml/Preface002'
 import XHTMLCHAPTER001 from '@/components/xhtml/Chapter001'
 import XHTMLPART001 from '@/components/xhtml/Part001'
 import XHTMLCHAPTER002 from '@/components/xhtml/Chapter002'
 import XHTMLCHAPTER003 from '@/components/xhtml/Chapter003'
 import XHTMLCHAPTER004 from '@/components/xhtml/Chapter004'
 import XHTMLPART002 from '@/components/xhtml/Part002'
 import XHTMLCHAPTER005 from '@/components/xhtml/Chapter005'
 import XHTMLCHAPTER006 from '@/components/xhtml/Chapter006'
 import XHTMLPART003 from '@/components/xhtml/Part003'
 import XHTMLCHAPTER007 from '@/components/xhtml/Chapter007'
 import XHTMLCHAPTER008 from '@/components/xhtml/Chapter008'
 import XHTMLPART004 from '@/components/xhtml/Part004'
 import XHTMLCHAPTER009 from '@/components/xhtml/Chapter009'
 import XHTMLCHAPTER010 from '@/components/xhtml/Chapter010'
 import XHTMLCHAPTER011 from '@/components/xhtml/Chapter011'
 import XHTMLQUESTIONS from '@/components/xhtml/Questions'
 import XHTMLINDEX from '@/components/xhtml/Index'
 import XHTMLBACK from '@/components/xhtml/Back'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/Contents",
 			"name" : "xhtml/Contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/Foreword",
 			"name" : "xhtml/Foreword",
 			"component" : XHTMLFOREWORD
 		},
 		{
 			"path" : "/xhtml/Preface001",
 			"name" : "xhtml/Preface001",
 			"component" : XHTMLPREFACE001
 		},
 		{
 			"path" : "/xhtml/Preface002",
 			"name" : "xhtml/Preface002",
 			"component" : XHTMLPREFACE002
 		},
 		{
 			"path" : "/xhtml/Chapter001",
 			"name" : "xhtml/Chapter001",
 			"component" : XHTMLCHAPTER001
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js